import LogoSVG from './LogoSVG';

/**
 * The HousingAI logo + wordmark lockup.
 *
 * Proportions come from the font-size on the wrapper, so a caller only sets type
 * (and colour) and everything follows: mark = 1.4em, gap = 0.35em — the same
 * ratios as the utility-allowance PDF header (24px mark, 13pt wordmark, 6px gap).
 *
 * Vertical alignment is done on the baseline, not the line box. A flex item's
 * synthesised baseline is its bottom border edge, so translateY(25%) lifts the
 * mark's centre — the roof corner, which the viewBox puts at exactly 50% height
 * — to cap-height/2 above the baseline, which is where the "H" crossbar sits.
 * -mt-[0.35em] cancels the extra line height baseline alignment would otherwise
 * add. Unlike align-items:center this holds whatever the font's ascent and
 * descent are, which is what kept the wordmark riding low in Segoe UI.
 */
const Brand = ({
  as: Tag = 'div',
  theme = 'light',
  markClassName = '',
  className = '',
  children = 'HousingAI',
  ...rest
}) => (
  <Tag className={`flex items-baseline gap-[0.175em] ${className}`} {...rest}>
    <LogoSVG
      theme={theme}
      className={`h-[1.4em] w-[1.4em] shrink-0 -mt-[0.35em] translate-y-[25%] ${markClassName}`}
    />
    <span>{children}</span>
  </Tag>
);

export default Brand;
